// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="#6421B9"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M18.3346 7.44265C18.3346 6.9378 18.3346 6.68538 18.2348 6.56849 18.1482 6.46707 18.0182 6.41325 17.8853 6.42371 17.732 6.43577 17.5535 6.61426 17.1966 6.97124L14.168 9.99984 17.1966 13.0284C17.5535 13.3854 17.732 13.5639 17.8853 13.576 18.0182 13.5864 18.1482 13.5326 18.2348 13.4312 18.3346 13.3143 18.3346 13.0619 18.3346 12.557V7.44265ZM1.66797 8.1665C1.66797 6.76637 1.66797 6.06631 1.94045 5.53153 2.18014 5.06112 2.56259 4.67867 3.03299 4.43899 3.56777 4.1665 4.26784 4.1665 5.66797 4.1665H10.168C11.5681 4.1665 12.2682 4.1665 12.8029 4.43899 13.2734 4.67867 13.6558 5.06112 13.8955 5.53153 14.168 6.06631 14.168 6.76637 14.168 8.1665V11.8332C14.168 13.2333 14.168 13.9334 13.8955 14.4681 13.6558 14.9386 13.2734 15.321 12.8029 15.5607 12.2682 15.8332 11.5681 15.8332 10.168 15.8332H5.66797C4.26784 15.8332 3.56777 15.8332 3.03299 15.5607 2.56259 15.321 2.18014 14.9386 1.94045 14.4681 1.66797 13.9334 1.66797 13.2333 1.66797 11.8332V8.1665Z"
    />
  </svg>
);
const IconVideoPurple = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconVideoPurple;
